import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Globe } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const LanguageSwitcher = ({ isScrolled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { currentLanguage, languages, changeLanguage } = useLanguage();
  const dropdownRef = useRef(null);
  const currentLang = languages.find(l => l.code === currentLanguage) || languages[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button onClick={() => setIsOpen(!isOpen)} className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-all ${isScrolled ? 'text-night hover:bg-gray-100' : 'text-white hover:bg-white/10'}`}>
        <Globe className="w-4 h-4" /><span className="hidden sm:inline">{currentLang?.flag_emoji}</span><span className="uppercase text-xs font-bold">{currentLanguage}</span><ChevronDown className={`w-3 h-3 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden z-50 animate-fade-in">{languages.map((lang) => <button key={lang.code} onClick={() => { changeLanguage(lang.code); setIsOpen(false); }} className={`w-full flex items-center gap-3 px-4 py-3 text-sm transition-colors ${currentLanguage === lang.code ? 'bg-crystal-blue/10 text-crystal-blue font-medium' : 'text-night hover:bg-gray-50'}`}><span className="text-lg">{lang.flag_emoji}</span><div className="text-left"><div>{lang.native_name}</div><div className="text-xs text-gray-400">{lang.name}</div></div></button>)}</div>}
    </div>
  );
};

export default LanguageSwitcher;
